<template>
  <div class="min-h-screen bg-gray-50 pt-20">
    <TermsAndConditions />
  </div>
</template>

<script setup lang="ts">
import TermsAndConditions from '../components/legal/TermsAndConditions.vue';
</script>
